module.exports = __webpack_public_path__ + "static/p2p-preview_925.5a3dd8bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p2p-preview_925.jpg
// module id = 451
// module chunks = 35783957827783